import { OAuthPage } from '@ppay/client'
import React from 'react'

import { routes } from '../../router'

export const Page = () => {
  return <OAuthPage loginPath={routes.auth.login} />
}
